import { CoralConfigSchema } from "@amzn/coral-client-config-types";
import { ConfiguredDomain } from "../auth/types";

// Non-Prod Configs
import sentinelAlphaConfig from "@amzn/dependencysentinel-client-config/generated/json/DependencySentinel-Base.Alpha.json";
import sentinelBetaConfig from "@amzn/dependencysentinel-client-config/generated/json/DependencySentinel-Base.Beta.json";

// Prod Config
import sentinelProdConfig from "@amzn/dependencysentinel-client-config/generated/json/DependencySentinel-Base.Prod.json";

export const DomainToClientConfig: {
  [key in ConfiguredDomain]: CoralConfigSchema;
} = {
  [ConfiguredDomain.PROD]: sentinelProdConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.BETA]: sentinelBetaConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.ALPHA]: sentinelAlphaConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.SAURAVTR]: sentinelAlphaConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.PRASPWR]: sentinelAlphaConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.ARVELE]: sentinelAlphaConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.WANBOJUN]: sentinelAlphaConfig as unknown as CoralConfigSchema,
  [ConfiguredDomain.JICINDY]: sentinelAlphaConfig as unknown as CoralConfigSchema,
};

export const getSentinelConfig: (url: string) => CoralConfigSchema = (
  url: string,
) => {
  return DomainToClientConfig[url as ConfiguredDomain];
};